import { useTranslation } from 'react-i18next'

import { connectRequestsToRequest } from '../../../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import { useNotification } from '../../../../../hooks'
import { getItemsIds } from '../../../../../utils/common'
import {
  AttachServiceRequestsModal,
  getRelatedRequestsLimitErrorMeta,
} from '../../../../Request'
import {
  useConnectedRequestsPreview,
  useRequestProfileContext,
} from '../../../RequestProfile.hooks'
import {
  REQUEST_PROFILE_ACTIONS_WIDGET_ATTACHED_REQUESTS_OPTION,
  REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY,
} from '../../RequestProfileActionsWidget.constants'

export function useRequestProfileAttachedRequestsActions({
  requestId,
  onClickCreate,
}) {
  const { t } = useTranslation()

  const {
    handleCloseModal,
    handleReloadAfterChange,
    outboundUuid,
    requestData,
    setModal,
  } = useRequestProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleReloadAfterSuccess() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.relatedRequests)
  }

  async function handleMassEditSuccess() {
    return handleReloadAfterChange(
      REQUEST_PROFILE_CHANGE_TYPE.providers,
      REQUEST_PROFILE_CHANGE_TYPE.relatedRequests
    )
  }

  const { handleClickOpenMassEdit } = useConnectedRequestsPreview({
    requestData,
    onCloseModal: handleCloseModal,
    onMassEditSuccess: handleMassEditSuccess,
    onSetModal: setModal,
  })

  async function handleAttachRequests({ selected, status }) {
    return connectRequestsToRequest({
      data: {
        ...(status ? { restore_archived_with_status: status } : EMPTY_OBJECT),
        requests: getItemsIds(selected),
      },
      id: requestId,
      outboundUuid,
    })
      .then(() => {
        handleAddSuccessNotification({
          title: t(
            REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY.connectRequests,
            {
              count: selected.length,
              totalCount: selected.length,
            }
          ),
        })

        handleReloadAfterSuccess()
        handleCloseModal()
      })
      .catch(error => {
        if (getRelatedRequestsLimitErrorMeta(error)) {
          throw error
        }

        handleAddErrorNotification('Error.CommonApiRequestFailKey')
        handleCloseModal()
      })
  }

  function handleClickAttach() {
    setModal(
      <AttachServiceRequestsModal
        multipleSelection
        showLimitNotification
        excludeIds={[
          ...(requestData?.related_request_ids || EMPTY_LIST),
          requestId,
        ]}
        onAttach={handleAttachRequests}
        onClose={handleCloseModal}
      />
    )
  }

  function handleSelectAttachedRequestsOption({ value }) {
    switch (value) {
      case REQUEST_PROFILE_ACTIONS_WIDGET_ATTACHED_REQUESTS_OPTION.attach:
        handleClickAttach()
        break
      case REQUEST_PROFILE_ACTIONS_WIDGET_ATTACHED_REQUESTS_OPTION.create:
        onClickCreate?.()
        break
      case REQUEST_PROFILE_ACTIONS_WIDGET_ATTACHED_REQUESTS_OPTION.massEdit:
        handleClickOpenMassEdit()
        break
      default:
        break
    }
  }

  return { handleSelectAttachedRequestsOption }
}
